export type UseLocationState = {
  from?: string
  to?: string
  consultationType?: ConsultationType
  consultationId?: number
  forwardState?: Record<string, unknown>
}

export enum ConsultationType {
  SCHEDULED = 'scheduled',
  IMMEDIATE = 'immediate',
}
